// extracted by mini-css-extract-plugin
export default {"videoContainer":"VideoContainer_videoContainer__aDAT7","videoElement":"VideoContainer_videoElement__AE8Ol"};